import type { SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  width: string
  height: string
  color?: string
}

const NewWishlistExperimentIcon = ({
  width,
  height,
  color,
  ...props
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4560_9588)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4635 0C11.0543 0 9.89272 0.769765 9.00014 1.60306C8.10755 0.769765 6.94602 0 5.53672 0C4.03425 0 2.63343 0.640588 1.59684 1.77776C-0.529276 4.10929 -0.532453 7.87341 1.58837 10.2081L8.31614 18H9.68414L16.4119 10.2081C18.5327 7.87235 18.5295 4.10929 16.4034 1.77776C15.3668 0.640588 13.966 0 12.4635 0ZM12.4635 1.85188C11.5043 1.85188 10.5831 2.538 9.66719 3.54282H8.33308C7.41719 2.538 6.49602 1.85188 5.53672 1.85188C4.55943 1.85188 3.63614 2.26376 2.93096 3.03776C1.44966 4.662 1.44966 7.33447 2.93096 8.95871L2.9479 8.97671L9.00014 15.9861L15.0524 8.97671L15.0693 8.95871C16.5506 7.33341 16.5506 4.662 15.0693 3.03776C14.3641 2.26376 13.4408 1.85188 12.4635 1.85188Z"
        fill={color ?? 'black'}
      />
    </g>
    <defs>
      <clipPath id="clip0_4560_9588">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default NewWishlistExperimentIcon
